(() => {
  const label = document.currentScript?.dataset.signatureLabel;
  if (!['de', 'en'].includes(document.documentElement.lang) || !label || !document.body) return;
  const selector = '.bss-price-container [bss-config-id="217639"] [data-bss-pl-text-id="bss-pl-text-217639"] p';
  const source = /^(\s*)Offre Signature(\s+-\d+(?:[.,]\d+)?\s*%\s*)$/;
  const translate = (element) => {
    if (!element.matches(selector)) return;
    for (const node of element.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && source.test(node.data)) {
        node.data = node.data.replace(source, (_, before, after) => before + label + after);
      }
    }
  };
  const scan = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.parentElement) translate(node.parentElement);
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      translate(node);
      node.querySelectorAll(selector).forEach(translate);
    }
  };
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'characterData') scan(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  scan(document.body);
})();
